/*=========================================================================================
  File Name: moduleCalendarGetters.js
  Description: Calendar Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  getInsightMiss: state => (Id) => state.insightMissDatas.find((miss) => miss.user_id == Id),
  getInsightLate: state => (Id) => state.insightLateDatas.find((late) => late.user_id == Id),
  getInsightDay: state => (day) => state.insightDays.find((insight) => insight.day_time.toLowerCase().includes(day.toLowerCase())),
  getInsightUser: state => (Id) => state.insightVector.find((vector) => vector.user_id == Id),  
}
